import { AuthControl, userManager } from '@/services/SecurityService';
import store from '@/store';
import { getBasicApiUrl, getBasicAuthUrl, getBasicFunctionUrl } from '@/services/helper.service';
import build from '@/assets/build-number.json';

class BaseApi {
  constructor() {
    let axios = require('axios');
    this.basicUrl = getBasicApiUrl();
    this.basicAuthUrl = getBasicAuthUrl();
    this.basicFunctionUrl = getBasicFunctionUrl();
    this.authControl = new AuthControl();
    this.client = axios.create();
  }

  async getClient() {
    let client = this.client;
    let authControl = this.authControl;
    let currentLanguage = localStorage.getItem('currentLanguage');
    let classContext = this;
    let buildNumber = build !== null ? build.buildNumber : '0.0.0.0';
    client.defaults.headers.common['Content-Type'] = 'application/json';
    client.defaults.headers.common['Accept-Language'] = currentLanguage ? currentLanguage : 'en';
    client.defaults.headers.common['clientType'] = 'web';
    client.defaults.headers.common['clientVersion'] = buildNumber;
    // setup up interceptor if it is not set already
    if (client.interceptors.response.handlers.length < 1) {
      client.interceptors.response.use(
        function(response) {
          return response;
        },
        function(error) {
          // log out user if token is expired
          if (typeof error.response !== 'undefined' && error.response.status === 401) {
            store.dispatch('logOutUser');
            userManager.signoutRedirect();
            userManager.removeUser();
          }
          classContext.dispatchErrorMessage(error.response.data);
          return Promise.reject(error);
        }
      );
    }

    return this.authControl.getUserToken().then(
      accessToken => {
        client.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;

        return client;
      },
      err => {
        console.log(err);
      }
    );
  }

  async getClientWithoutToken() {
    let client = this.client;
    let buildNumber = build !== null ? build.buildNumber : '0.0.0.0';
    client.defaults.headers.common['Content-Type'] = 'application/json';
    client.defaults.headers.common['clientType'] = 'web';
    client.defaults.headers.common['clientVersion'] = buildNumber;
    delete client.defaults.headers.common['Authorization'];

    return client;
  }

  dispatchErrorMessage(response) {
    store.dispatch('setSnackAction', this.parseErrorMessage(response));
  }

  parseErrorMessage(response) {
    let { data, status, statusText } = response;
    let responseArray = [];

    if (typeof statusText === 'string' && statusText !== '') {
      responseArray.push(statusText);
      return responseArray;
    }
    if (Array.isArray(response.errors) && response.errors.length > 0) {
      return response.errors.map(error => {
        return error.message;
      });
    }
    if (response.hasOwnProperty('error_description')) {
      responseArray.push(response.error_description);
      return responseArray;
    }
  }
}

export default BaseApi;
